// Wall wisp placement (pure): seeded, capped, spaced anchors on wall tiles.

import { LAND_TOP_LIFT, LEVEL_STEP } from '../elevation.js';
import { rng } from './seaRoutes.js';
import { axialXZ, parseKey } from './seaTiles.js';

export const WISP_CAP = 40;

export interface WispAnchor {
  readonly x: number;
  readonly y: number;
  readonly z: number;
  readonly size: number;
}

/** Wisp anchors on wall tiles: seeded, capped, spaced >= 1.6 apart. Pure. */
export function wispAnchors(
  wall: ReadonlyMap<string, number>,
  seed: number,
  cap = WISP_CAP,
): WispAnchor[] {
  const keys = [...wall.keys()].sort();
  const rand = rng(seed ^ 0x9e37);
  for (let i = keys.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [keys[i], keys[j]] = [keys[j]!, keys[i]!];
  }
  const out: WispAnchor[] = [];
  for (const k of keys) {
    if (out.length >= cap) break;
    const [q, r] = parseKey(k);
    const [x, z] = axialXZ(q, r);
    if (out.some((a) => Math.hypot(a.x - x, a.z - z) < 1.6)) continue;
    const row = wall.get(k) ?? 0;
    const level = 12 - row;
    out.push({
      x,
      y: LAND_TOP_LIFT + level * LEVEL_STEP + 0.35 + rand() * 0.5,
      z,
      size: 2.2 + rand() * 1.4,
    });
  }
  return out;
}
